import { useMemo } from 'react';
import { isPhone, isWeb } from '@helpers';
import { fullWidth, scale } from '@components/frame';
import { LIST_WIDTH } from '@v2/pages/common/constants/base.constants';
import { useWindowDimensions } from 'react-native';

export const useDeviceSize = () => {
  const IS_NARROW_WEB = useMemo(() => isWeb && isPhone, [isWeb, isPhone]);
  const IS_WIDE_WEB = useMemo(() => isWeb && !isPhone, [isWeb, isPhone]);

  const { width } = useWindowDimensions();

  const detailsWidth = width - scale(LIST_WIDTH);

  return { IS_NARROW_WEB, IS_WIDE_WEB, detailsWidth, fullWidth: width };
};
